import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import { Logger } from 'utils/Logger';
import { requestActionsFailure, requestActionsSuccess } from './actions';
import { actions } from './types';

const logger = new Logger('Saga:Dashboard:Actions');

export function* getActions(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const casesActions = yield call(
      authApiService.get,
      routerService.generate('api.platform.cases_actions'),
    );
    const coursesActions = yield call(
      authApiService.get,
      routerService.generate('api.learning.courses_actions'),
    );
    const monitorActions = yield call(
      authApiService.get,
      routerService.generate('api.monitor.clients_actions', {
        entityId: action.entityId,
      }),
    );

    logger.info('Got new actions');

    const data = [...casesActions.data, ...coursesActions.data, ...monitorActions.data];

    if (action.promise) action.promise.resolve(data);

    yield put(requestActionsSuccess(data));
  } catch (error) {
    logger.error(error);
    if (action.promise) action.promise.reject(error);
    yield put(requestActionsFailure(error));
  }
}

export default function* activitiesSaga() {
  return yield all([takeLatest(actions.request, getActions)]);
}
